import { QRCodeCanvas } from "qrcode.react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppServices } from "../../../../../../hook/services";

const AddDeviceModal = () => {
  const AppService = useAppServices();
  const { locationId, companyId } = useParams();
  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getQrCodeUrl = async () => {
    const { response } = await AppService.webhook.qr_code({
      query: `locationId=${locationId}&companyId=${companyId}`,
    });
    if (response) {
      setQrCodeUrl(response.url);
    }
  };

  useEffect(() => {
    getQrCodeUrl();
  }, []);

  return (
    <>
      {/* Modal */}
      <button
        className="btn btn-primary px-4 py-2 rounded-3 shadow-sm"
        onClick={handleOpen}
      >
        <i className="bi bi-plus-circle me-2"></i>
        Add New Device
      </button>
      {open && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow">
              <div className="modal-header bg-light">
                <h5 className="modal-title fw-bold" id="addDeviceModalLabel">
                  Add Device
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                ></button>
              </div>
              <div className="modal-body p-4">
                {qrCodeUrl ? (
                  <div className="d-flex justify-content-center my-4">
                    <QRCodeCanvas
                      value={qrCodeUrl}
                      size={200}
                      level="H"
                      includeMargin={true}
                    />
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddDeviceModal;
